import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Button, Grid } from "@mui/material";
import { useEffect } from "react";
import GetAsignaturas from "../../data/GetAsignaturas";
import GetNiveles from "../../data/GetNiveles";
import AdaptacionesCurriculares from "../../components/Form/Fields/AdaptacionesCurriculares";
import CriteriosEvaluacion from "../../components/Form/Fields/CriteriosEvaluacion";
import DescripcionTareaAutoCoevaluacion from "../../components/Form/Fields/DescripcionTareaAutoCoevaluacion";
import FormatoEvaluacion from "../../components/Form/Fields/FormatoEvaluacion";
import TipoEvaluacion from "../../components/Form/Fields/TipoEvaluacion";
import AutoCoevaluacionCardImg from "../../components/UmmIApps/Cards/AutoCoevaluacionCardImg.png";
import GetObjetivosAprendizaje from "../../components/ObjetivosAprendizaje/GetObjetivosAprendizaje";
import { useActividadesContext } from "../../components/UmmIACategories/Hook/useActividades";
import UmmiaAppsLayout from "../../components/UmmIACategories/Layout/UmmiaAppsLayout";

const AutoCoevaluacionPage = () => {
  const {
    nivelId,
    materiaId,
    promptData,
    handleBack,
    setTextoInicial,
    toggleCamposAvanzados,
    mostrarCamposAvanzados,
    isOAAdded,
    handleNivelChange,
    handleAsignaturaChangeLocal,
    handleInitialPromptData,
  } = useActividadesContext();

  //Variable para condicionar la habilitación del botón "Generar"
  const isButtonDisabled = !(
    promptData.nivel &&
    promptData.materia &&
    promptData.tipo_evaluacion &&
    promptData.formato &&
    promptData.descripcion_actividad &&
    isOAAdded
  );
  const colorIconBack = "#E29930";

  useEffect(() => {
    const init = {
      nivel: "",
      materia: "",
      objetivos: [],
      tipo_evaluacion: "",
      formato: "",
      descripcion_actividad: "",
      criterios_evaluacion: [],
      adaptaciones_curriculares: "",
    };
    handleInitialPromptData(init, "autoevaluacion");
    setTextoInicial(
      "Esta es la propuesta que tengo para ti. Puedes revisarla y modificar cualquier parte según tus necesidades. Ajusta los parámetros en 'Mostrar campos', genera una nueva versión con 'Volver a generar' o personaliza el contenido con 'Editar'. Si prefieres trabajar en otra plataforma, usa 'Copiar' para llevar el texto donde desees."
    );
  }, []);

  return (
    <>
      <UmmiaAppsLayout
        onBack={handleBack}
        imageSrc={AutoCoevaluacionCardImg}
        backgroundColorImage={
          "linear-gradient(180deg, #FFFFFF 0%, #F8ED9B 100%, #F1DB37 100%)"
        }
        titleColor="#F9A825"
        title="Auto y coevaluación"
        description="Genera instrumentos de auto y coevaluación para que los estudiantes puedan evaluar su propio trabajo y el de sus compañeros"
        isButtonDisabled={isButtonDisabled}
        colorIconBack={colorIconBack}
      >
        <Grid item xs={12} lg={12} display="flex" flexDirection="row">
          <Grid item xs={12} sm={6} md={6} lg={12} sx={{ mr: 2, mb: 4 }}>
            <GetNiveles
              onNivelChange={handleNivelChange}
              selectedNivel={nivelId}
            />
          </Grid>

          {/* Nuevo componente para consultar y probar el endpoint de asignaturas */}
          <Grid item xs={12} sm={6} md={6} lg={12} sx={{ mb: 4 }}>
            <GetAsignaturas
              nivelId={nivelId}
              onAsignaturaChange={handleAsignaturaChangeLocal}
              selectedAsignatura={materiaId}
            />
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12}>
          <GetObjetivosAprendizaje
            nombreAsignatura={promptData.materia}
            nombreNivel={promptData.nivel}
          />
        </Grid>
        <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
          <TipoEvaluacion />
        </Grid>
        <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
          <FormatoEvaluacion />
        </Grid>
        <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
          <DescripcionTareaAutoCoevaluacion />
        </Grid>

        <Grid item xs={12} container justifyContent="center" sx={{ mb: 3 }}>
          <Button
            variant="text"
            sx={{ color: "#336B87" }}
            onClick={toggleCamposAvanzados}
            endIcon={
              mostrarCamposAvanzados ? <ExpandMoreIcon /> : <ExpandMoreIcon />
            }
          >
            {mostrarCamposAvanzados
              ? "Ocultar opciones avanzadas"
              : "Mostrar opciones avanzadas (opcional)"}
          </Button>
        </Grid>
        {/* Campos avanzados */}
        {mostrarCamposAvanzados && (
          <>
            <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
              <CriteriosEvaluacion />
            </Grid>
            <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
              <AdaptacionesCurriculares />
            </Grid>
          </>
        )}
      </UmmiaAppsLayout>
    </>
  );
};

export default AutoCoevaluacionPage;
